import { bindable, inject } from 'aurelia-framework';
import { DOM } from 'aurelia-pal';
import { State } from '../../services/global-state';

@inject(Element, State)
export class TermsConditionsCustomElement {
	@bindable hideAgreed: any;
	element: Element;
	state: State;
	smsEnabled: boolean;

	constructor(element: Element, state: State) {
		this.element = element;
		this.state = state;
		this.smsEnabled = false;

		try {
			this.smsEnabled = this.state.business.portalSettings.businessSettings.enableSMS;
		}
		catch (err) {
			this.smsEnabled = false;
		}
	}

	theyAgreed() {
		let eventData = { value: true };
		let evt = DOM.createCustomEvent('agreed', { bubbles: true, cancelable: true, detail: eventData });
		this.element.dispatchEvent(evt);
	}
}
